import * as React from 'react';
import { ApplicationContainer } from '../../../../shared/components/widget/Application';
import { IReduxStore } from '../../../../shared/types/redux';
import { IWidgetApplicationContext } from '../../../../shared/types/widgetContext';
import { createRoot } from 'react-dom/client';
import { WebComponent, UIRuntimeBuilder } from '@cian/mf-registry/browser';

interface IParams {
  context: IWidgetApplicationContext;
  store: IReduxStore;
}

export const createMicrofrontendUI = (params: IParams) => (): UIRuntimeBuilder => {
  const { context, store } = params;

  class PaymentWidget extends WebComponent {
    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = '/public/v1/get-widget/';

    public async render() {
      const root = createRoot(this);
      root.render(<ApplicationContainer {...this.props} context={context} store={store} />);
    }
  }

  return {
    customElementConstructor: PaymentWidget,
  };
};
